import { trpc } from '@/shared/api/trpc';

const FIVE_MINUTES = 5 * 60 * 1000;

export const useOperationStatusesData = () =>
  trpc.operations.statuses.useQuery(undefined, {
    staleTime: FIVE_MINUTES,
  });
